import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dateInput", "startTimeInput", "endTimeInput",
    "output", "dateOutput", "startTimeOutput", "endTimeOutput"
  ]

  connect() {
    // Update immediately using initial values
    this.updateDisplay()

    // Listen to changes
    this.dateInputTarget.addEventListener("input", this.updateDisplay.bind(this))
    this.startTimeInputTarget.addEventListener("input", this.updateDisplay.bind(this))
    this.endTimeInputTarget.addEventListener("input", this.updateDisplay.bind(this))
  }

  updateDisplay() {
    const dateValue = this.dateInputTarget.value
    const startTimeValue = this.startTimeInputTarget.value
    const endTimeValue = this.endTimeInputTarget.value

    // Format and update date & month name
    if (dateValue) {
      const date = new Date(dateValue)
      const monthName = date.toLocaleString('default', { month: 'long' })
      const day = String(date.getDate()).padStart(2, '0')
      const weekday = date.toLocaleString('default', { weekday: 'short' })
      const formattedDate = `${monthName} ${day}, ${weekday}`

      const monthTemplate = this.outputTarget.dataset.template || this.outputTarget.textContent
      this.outputTarget.textContent = monthTemplate.replace(/\*\|month_name\|\*/gi, monthName)

      const dateTemplate = this.dateOutputTarget.dataset.template || this.dateOutputTarget.textContent
      this.dateOutputTarget.textContent = dateTemplate.replace(/\*\|date\|\*/gi, formattedDate)
    }

    // Helper to format time to 12-hour AM/PM
    const formatTime = (timeStr) => {
      if (!timeStr) return ""
      const [hour, minute] = timeStr.split(":")
      const h = parseInt(hour)
      const m = parseInt(minute)
      const ampm = h >= 12 ? 'pm' : 'am'
      const h12 = h % 12 || 12
      const paddedHour = String(h12).padStart(2, '0')
      const paddedMinute = String(m).padStart(2, '0')
      return `${paddedHour}:${paddedMinute}${ampm}`
    }

    // Format and update start time
    if (startTimeValue) {
      const formattedStart = formatTime(startTimeValue)
      const startTemplate = this.startTimeOutputTarget.dataset.template || this.startTimeOutputTarget.textContent
      this.startTimeOutputTarget.textContent = startTemplate.replace(/\*\|start_time\|\*/gi, formattedStart)
    }

    // Format and update end time
    if (endTimeValue) {
      const formattedEnd = formatTime(endTimeValue)
      const endTemplate = this.endTimeOutputTarget.dataset.template || this.endTimeOutputTarget.textContent
      this.endTimeOutputTarget.textContent = endTemplate.replace(/\*\|end_time\|\*/gi, formattedEnd)
    }
  }
}
